import { TerminalConfigurationInterface } from "@/interface/common/terminal_configuration_interface";

export class TerminalConfiguration {
  async fetchTerminalConfiguration(url: string): Promise<TerminalConfigurationInterface> {
    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json"
        }
      });
      const data = await res.json();
      const containers = data as TerminalConfigurationInterface;
      return containers;
    } catch (error) {
      console.error("Failed to load JSON", error);
    }
  }
}
